export default "__VITE_ASSET__qyUHAAK1__"